import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
//local
import cn from "classnames";

const baseClass = "signing_contract__timeline";

const SignContractTimeline = ({contract, addClass}) => {
  const {t} = useTranslation();

  const haveDocuments = useMemo(() => !!contract?.files?.contracts?.length, [contract]);
  const haveSigningParties = useMemo(
    () =>
      contract?.initiatingMembers?.length > 0 &&
      contract?.counterpartyMembers?.length > 0,
    [contract]
  );

  return (
    <div className={cn(`${baseClass}`, {[addClass]: !!addClass})}>
      <span className={`${baseClass}__start`}>
        {t("SIGN_CONTRACT_TIMELINE_STEP_ZERO_LABEL")}
      </span>
      <span className={cn(`${baseClass}__circle`, {filled: haveDocuments})}></span>
      <span className={cn(`${baseClass}__line`, {filled: haveDocuments})}>
        {t("SIGN_CONTRACT_TIMELINE_STEP_ONE_LABEL")}
      </span>
      <span className={cn(`${baseClass}__circle`, {filled: haveSigningParties})}></span>
      <span className={cn(`${baseClass}__line`, {filled: haveSigningParties})}>
        {t("SIGN_CONTRACT_TIMELINE_STEP_TWO_LABEL")}
      </span>
      <span className={cn(`${baseClass}__dot`, {filled: haveSigningParties})}></span>
    </div>
  );
};

export default SignContractTimeline;
